module.exports = __webpack_public_path__ + "static/media/demo500Small.af78001d.mp4";